var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaceEmojiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.365,
    height: 57.365,
    viewBox: "0 0 57.365 57.365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160814",
    "data-name": "Group 160814",
    transform: "translate(-736.817 -400.781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "face-id-svgrepo-com",
    transform: "translate(735.817 399.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    d: "M20.717,32.741C6.127,32.741,3,29.614,3,15.024",
    transform: "translate(0 23.624)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    d: "M32.741,15.024c0,14.59-3.127,17.717-17.717,17.717",
    transform: "translate(23.624 23.624)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    d: "M15.024,3c14.59,0,17.717,3.127,17.717,17.717",
    transform: "translate(23.624 0)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    "data-name": "Path 2278",
    d: "M8,14a14.826,14.826,0,0,0,23.72,0",
    transform: "translate(9.824 21.612)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    d: "M9,10.033V10",
    transform: "translate(11.788 13.753)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M15,10.033V10",
    transform: "translate(23.577 13.753)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M3,20.717C3,6.127,6.127,3,20.717,3",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceEmojiIcon);
export default __webpack_public_path__ + "static/media/face-emoji-icon.a034e4b6a33d1a1ab637843d4f26af47.svg";
export { ForwardRef as ReactComponent };